import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, Chip, Divider, Grid2, IconButton, Paper, Stack, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import { useParams } from 'react-router-dom';
import PaginationComponent from 'components/ui-components/PaginationComponent';
import TableDataGrid from 'components/grid/TableDataGrid';
import moment from 'moment';
import ExportToExcel from "../Risk/ExportToExcel";
import ExportToPDF from "../Risk/ExportToPDF";
import { useGetAllChangeQuery } from "store/slices/apis/changeTrackerPackageSlice";


const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%',
}));

export default function ChangeOrderPopup({ title, value, status, onClose, onOpen }) {
    const theme = useTheme();
    const { projectId } = useParams();
    const [pageNumber, setPageNumber] = React.useState(1);

    let searchparams = {
        projectId: projectId,
        page: pageNumber,
        pageSize: 10,
        sortBy: 'createddate',
        sortOrder: 'desc',
        approved_status: 'Approved',
    }

    if (status == 'changeOrderByContractor') {
        searchparams = {
            ...searchparams,
            consultant_contractor: value
        }
    }
    // else {
    //     searchparams = {
    //         ...searchparams,
    //     }
    // }

    const { data: openCloseData = {}, error: openCloseError, isLoading: isOpenCloseLoading } = useGetAllChangeQuery(searchparams);

    const columns = [
        {
            name: "Change Order ID",
            field: "change_number",
            renderExport: (row) => row?.change_number || "",
        },
        { name: "Category", field: "package", renderExport: (row) => row?.package || "" },
        { name: "Sub Category 1", field: "sub_package1", renderExport: (row) => row?.sub_package1 || "" },
        {
            name: "Workflow Status",
            field: "approved_status",
            renderer: (row) =>
                row?.approved_status === "Pending_for_Approval"
                    ? "Pending for approval"
                    : row?.approved_status,
            renderExport: (row) =>
                row?.approved_status === "Pending_for_Approval"
                    ? "Pending for approval"
                    : row?.approved_status || "",
        },
        { name: "Current Status", field: "status", renderExport: (row) => row?.status || "" },
        {
            name: "Created Date",
            field: "createddate",
            renderer: (row) =>
                row?.createddate ? moment(row.createddate).format("DD/MM/YY") : "N.A.",
            renderExport: (row) =>
                row?.createddate ? moment(row.createddate).format("DD/MM/YY") : "",
        },
        { name: "Contractor Number", field: "contractor_number", renderExport: (row) => row?.contractor_number || "" },
        { name: "Consultant Contractor", field: "consultant_contractor", renderExport: (row) => row?.consultant_contractor || "" },
        { name: "Change Raised To", field: "change_raised_to", renderExport: (row) => row?.change_raised_to || "" },
        {
            name: "Change Received On",
            field: "change_received_on",
            renderer: (row) =>
                row?.change_received_on ? moment(row.change_received_on).format("DD/MM/YY") : "N.A.",
            renderExport: (row) =>
                row?.change_received_on ? moment(row.change_received_on).format("DD/MM/YY") : "",
        },
        { name: "Change Raised By Reference", field: "change_raised_by_refrence", renderExport: (row) => row?.change_raised_by_refrence || "" },
        {
            name: "Change Raised By Date Received",
            field: "change_raised_by_date_received",
            renderer: (row) =>
                row?.change_raised_by_date_received
                    ? moment(row.change_raised_by_date_received).format("DD/MM/YY")
                    : "N.A.",
            renderExport: (row) =>
                row?.change_raised_by_date_received
                    ? moment(row.change_raised_by_date_received).format("DD/MM/YY")
                    : "",
        },
        {
            name: "Change Raised To Date Of Response",
            field: "change_raised_to_date_of_response",
            renderer: (row) =>
                row?.change_raised_to_date_of_response
                    ? moment(row.change_raised_to_date_of_response).format("DD/MM/YY")
                    : "N.A.",
            renderExport: (row) =>
                row?.change_raised_to_date_of_response
                    ? moment(row.change_raised_to_date_of_response).format("DD/MM/YY")
                    : "",
        },
        { name: "Change Raised To Position", field: "change_raised_to_position", renderExport: (row) => row?.change_raised_to_position || "" },
        { name: "Change Raised By Estimate Cost Impact", field: "change_raised_by_estimate_cost_impact", renderExport: (row) => row?.change_raised_by_estimate_cost_impact || "" },
        { name: "Change Raised To Estimate Cost Impact", field: "change_raised_to_estimate_cost_impact", renderExport: (row) => row?.change_raised_to_estimate_cost_impact || "" },
        { name: "Change Raised By Estimate Time Impact", field: "change_raised_by_estimate_time_impact", renderExport: (row) => row?.change_raised_by_estimate_time_impact || "" },
        { name: "Change Raised To Estimate Time Impact", field: "change_raised_to_estimate_time_impact", renderExport: (row) => row?.change_raised_to_estimate_time_impact || "" },
        { name: "Approved Time Impact", field: "approved_time_impact", renderExport: (row) => row?.approved_time_impact || "" },
        {
            name: "Actual Date Of Closure",
            field: "actual_date_of_closure",
            renderer: (row) =>
                row?.actual_date_of_closure
                    ? moment(row.actual_date_of_closure).format("DD/MM/YY")
                    : "N.A.",
            renderExport: (row) =>
                row?.actual_date_of_closure
                    ? moment(row.actual_date_of_closure).format("DD/MM/YY")
                    : "",
        }
    ];

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={onOpen}
                onClose={onClose}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid2 container spacing={2}>
                            <Grid2 container spacing={2} size={12}>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToExcel data={openCloseData?.data} columns={columns} fileName="change_export" />
                                </Grid2>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToPDF data={openCloseData?.data} columns={columns} fileName="change_export" />
                                </Grid2>
                            </Grid2>
                            <Grid2 size={12}>
                                <TableDataGrid columns={columns} data={openCloseData?.data} isLoading={isOpenCloseLoading} />

                                <Box sx={{ display: "flex", justifyContent: "end" }}>
                                    <PaginationComponent
                                        pageNumber={openCloseData?.pagination?.currentPage || 1}
                                        totalPages={openCloseData?.pagination?.totalPages || 1}
                                        onPageChange={setPageNumber}
                                    />
                                </Box>

                            </Grid2>
                        </Grid2>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}